var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditPencilFilled = function SvgEditPencilFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.224 9.485 4.88 22.828A4 4 0 0 1 2.053 24H0v-2.053a4 4 0 0 1 1.172-2.828L14.515 5.776zM21.29.086a2.623 2.623 0 0 1 1.855 4.478l-3.507 3.507-3.71-3.709L19.436.854A2.62 2.62 0 0 1 21.29.086"
  })));
};
export default SvgEditPencilFilled;